export default __webpack_public_path__ + "static/media/aakash-byjus-logo.e5533d99.svg";